import React from "react";
import { CiFacebook, CiTwitter, CiInstagram } from "react-icons/ci";
import { PiTiktokLogo } from "react-icons/pi";
import { Link } from "react-router-dom";
import Logo from "../common/Logo";
import StoreCard from "../features/StoreCard";
import { ROUTES, STORES } from "../../configs";

const Footer: React.FC = () => {
  const renderedStores = STORES.map((store, index) => (
    <StoreCard
      key={index}
      title={store.title}
      imagePath={store.imagePath}
    />
  ));
  const iconClasses = "cursor-pointer hover:text-primary";
  return (
    <div className="w-full flex flex-col md:flex-row gap-4 border-t border-gray-200 px-8 py-16">
      <div className="w-full md:w-1/5 flex flex-col items-center gap-5">
        <Logo />
        <div className="flex gap-2 text-3xl">
          <CiFacebook className={iconClasses} />
          <CiTwitter className={iconClasses} />
          <CiInstagram className={iconClasses} />
          <PiTiktokLogo className={iconClasses} />
        </div>
        <div className="font-thin text-xs text-gray-500">© 2025 • BipBip</div>
      </div>
      <div className="w-full w-4/5 flex flex-col md:flex-row gap-6 items-center justify-evenly">
        <div className="flex flex-col gap-6 text-gray-600">
          <Link
            to="/"
            className="hover:text-primary cursor-pointer"
          >
            Commander
          </Link>
          <Link
            to={ROUTES.RESTAURANT_REQUEST}
            className="hover:text-primary cursor-pointer"
          >
            Ajouter mon restaurant
          </Link>
          <Link
            to={ROUTES.RIDER_REQUEST}
            className="hover:text-primary cursor-pointer"
          >
            Devenir couriser
          </Link>
          <Link
            to="/politique-de-confidentialite"
            className="hover:text-primary cursor-pointer"
          >
            Politique de confidentialité
          </Link>
          <Link
            to="/mentions-legales"
            className="hover:text-primary cursor-pointer"
          >
            Mentions légales
          </Link>
          <Link
            to="/cgv"
            className="hover:text-primary cursor-pointer"
          >
            CGV
          </Link>
        </div>
        <div className="flex flex-col gap-3">{renderedStores}</div>
      </div>
    </div>
  );
};

export default Footer;
